<div class="variants" [@leave]>
  <div class="variant touch-eff"
       *ngFor="let item of variants" (click)="onSelect(item)"
       [ngClass]="{'active': item === value}"
  >
    {{item ? item : 'N/A'}}
  </div>
</div>
